/**
 * A missing value in words (hard rule 10): never a 0, never "none". Owner: slice web-charts (#1115).
 */
import { cn } from '@patchbay/ui'
import type { MetricState } from './format'

export const STATE_LABEL: Record<Exclude<MetricState, 'ok'>, string> = {
  insufficient: 'Too few cases',
  not_tracked: 'Not tracked yet',
  unavailable: "Couldn't load",
}

export function StateText({
  state,
  note,
  sample,
  className,
}: {
  state: MetricState
  note?: string | null
  sample?: number | null
  className?: string
}) {
  if (state === 'ok') return <span data-state="ok" className={className} />
  const showSample = state === 'insufficient' && sample !== null && sample !== undefined
  const showNote = state !== 'insufficient' && note
  return (
    <span data-state={state} className={cn('text-sm text-muted-foreground', className)}>
      <span className="font-medium">{STATE_LABEL[state]}</span>
      {showSample ? <span className="tabular"> (n={sample})</span> : null}
      {showNote ? <span className="block text-xs">{note}</span> : null}
    </span>
  )
}
